import { library } from '@fortawesome/fontawesome-svg-core';
import brandsIcons from './brands';
import regularIcons from './regular';
import solidIcons from './solid';

// make icons generally available in the application
library.add(...brandsIcons, ...regularIcons, ...solidIcons);

// export the curated list of icons
const icons = [...brandsIcons, ...regularIcons, ...solidIcons];
export { icons };
